import React, { useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ZipLongDistanceConfirmContext } from 'site-modules/shared/components/lead-form/zip-long-distance-confirm/zip-long-distance-confirm-context';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VisitorModel } from 'client/data/models/visitor';
import { isZipLongDistance } from 'client/site-modules/shared/utils/lead-form/hide-embedded-lead-form';

export const ZipLongDistanceConfirmProviderUI = ({ children, isUserSetZip = false, zipCode, stateCode = null }) => {
  const [isZipFormEnabled] = useState(() => isZipLongDistance({ isUserSetZip, zipCode, stateCode }));
  const [showZipLongDistanceConfirm, setZipLongDistanceConfirm] = useState(isZipFormEnabled);

  const handleSetZipLongDistanceConfirm = useCallback(() => {
    setZipLongDistanceConfirm(false);
  }, []);

  const value = useMemo(
    () => ({
      showZipLongDistanceConfirm,
      setZipLongDistanceConfirm: handleSetZipLongDistanceConfirm,
    }),
    [showZipLongDistanceConfirm, handleSetZipLongDistanceConfirm]
  );

  return isZipFormEnabled ? (
    <ZipLongDistanceConfirmContext.Provider value={value}>{children}</ZipLongDistanceConfirmContext.Provider>
  ) : (
    children
  );
};

ZipLongDistanceConfirmProviderUI.propTypes = {
  children: PropTypes.node.isRequired,
  isUserSetZip: PropTypes.bool,
  zipCode: PropTypes.string.isRequired,
  stateCode: PropTypes.string,
};

const stateToPropsConfig = {
  zipCode: bindToPath('location.zipCode', VisitorModel),
  isUserSetZip: bindToPath('location.userSet', VisitorModel),
  stateCode: bindToPath('location.stateCode', VisitorModel),
};

export const ZipLongDistanceConfirmProvider = connectToModel(ZipLongDistanceConfirmProviderUI, stateToPropsConfig);
